import React from 'react'
import  { useState } from 'react';
import Styles from "../../Styles/DashBoard.module.css"
import TopBar from "../../Components/LayoutWapper/Global/TopBar";
import Frontend from '../../Components/ApplicationDetails/Frontend';
import UI from '../../Components/ApplicationDetails/UI';
import Sidebar from "../../Components/LayoutWapper/Global/SideBar";
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';





function Index() {


  const [activeTab, setActiveTab] = useState("tab1");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  function toggleSidebar() {
    setIsSidebarOpen(!isSidebarOpen);
  }

  // handle tab switching
  const handleTab1 = () => {
    setActiveTab("tab1");
  };

  const handleTab2 = () => {
    setActiveTab("tab2");
  };


  return  (
      <div className={Styles.container}>
      <TopBar toggleSidebar={toggleSidebar}/>
      <div className={Styles.main} >
       <div className={Styles.context} >
       <div className={Styles.nav}>
       {isSidebarOpen && <Sidebar />}
       </div>
       <div className={Styles.center}>
        <div className={Styles.info}>
        <div className={Styles.Header}>
         <h1>Submitted Applications</h1> 
        </div>
          <div className={Styles.jobcontainer} >
            <div className={Styles.col1} >
              <div className={Styles.card} id={Styles.card}>
             <div className={Styles.selectjob}>
              <div className={Styles.jobsection}>
                <div className={Styles.section1}>
                 <div className={Styles.subsection}>
                  <div  className={activeTab === "tab1" ? Styles.active : ""}
                     onClick={handleTab1}
                     id={Styles.carded}
                  
                  >
                    <div className={Styles.carddetails} id={Styles.caddetails}>
                     <ul>
                      <li className={Styles.head} >UI/UX Designer</li>
                      <li>Cdlp Hub Ltd</li>
                      <li>Ibadan</li>
                      <li>On-site</li>
                      <li className={Styles.tail}>Applied today</li>
                     </ul>
                     <div className={Styles.infolist} id={Styles.list}  >
                       <BusinessCenterOutlinedIcon sx={{ width:"16.67px", height:"15.83px" , color:"rgba(243, 114, 63, 1)"}}/>
                        <p>Applied</p>
                     </div>
                    </div>
                  </div>
                  <div className={activeTab === "tab2" ? Styles.active : ""}
                     onClick={handleTab2}
                     id={Styles.carded} >
                   <div className={Styles.carddetails} >
                   <ul>
                      <li className={Styles.head}>Frontend Developer</li>
                      <li>Cdlp Hub Ltd</li>
                      <li>Ibadan</li>
                      <li>On-site</li>
                      <li className={Styles.tail}  >Applied today</li>
                     </ul> 
                     <div className={Styles.infolist} id={Styles.list2} >
                       <BusinessCenterOutlinedIcon sx={{ width:"16.67px", height:"15.83px" , color:"rgba(243, 114, 63, 1)"}}/>
                        <p>Applied</p>
                     </div>
                  </div>
                  </div>
                 </div>
                </div>
                <div className={Styles.section2}>
                <div className={Styles.subsec1}>
                 {/* content goes here */}
          {activeTab === "tab1" ? <UI/> : <Frontend />} 
               </div>
                </div>
              </div>
             </div>
              </div>
            </div>
          </div>
          </div>
          </div>
         </div>
       </div> 
       </div>
      
  )
}

export default Index;